import { render } from "./MapLink.vue?vue&type=template&id=0c1767a5"
import script from "./MapLink.vue?vue&type=script&lang=js"
export * from "./MapLink.vue?vue&type=script&lang=js"
script.render = render

export default script